module.exports = __webpack_public_path__ + "static/img/dynamics.73a7a29.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamics.png
// module id = 3Nfj
// module chunks = 45